exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app{display:flex;min-height:100vh;flex-direction:column;margin:0}*{box-sizing:border-box}body{min-height:100vh;flex-direction:column;margin:0}#main,body{display:flex}#main{flex:1}#main>aside{flex:0 0 10vw}.footer{height:10vh}nav.navbar{padding:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./node_modules/eslint-loader!./src/App.vue?vue&type=style&index=0&lang=css
// module id = 137
// module chunks = 0